import _copyObject_default from "./_copyObject.js";
import keys_default from "./keys.js";

//#region ../../node_modules/lodash-es/_baseAssign.js
/**
* The base implementation of `_.assign` without support for multiple sources
* or `customizer` functions.
*
* @private
* @param {Object} object The destination object.
* @param {Object} source The source object.
* @returns {Object} Returns `object`.
*/
function baseAssign(object, source) {
	return object && _copyObject_default(source, keys_default(source), object);
}
var _baseAssign_default = baseAssign;

//#endregion
export { _baseAssign_default as default };
//# sourceMappingURL=_baseAssign.js.map